(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-results/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/modules/game-results/assets/javascripts/init.js');

'use strict';

svs.game_results.init = () => {
  svs.game_results.app.start();
};
svs.game_results.initGame = () => {
  svs.game_results.app.start();
};

 })(window);